var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-clickable',_vm._b({staticClass:"flat-button-container",class:( _obj = {}, _obj[_vm.color.toLowerCase()] = true, _obj['fixed-width'] =  _vm.fixedWidth, _obj ),attrs:{"tag":"button","disabled":_vm.busy || _vm.$attrs.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},'ui-clickable',_vm.$attrs,false),[(_vm.busy)?_c('spinner'):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }